import type { Employee, Team } from 'common/types.typescript';

export function getFullName(firstName: string, lastName: string) {
  return `${firstName} ${lastName}`;
}

export function getFullEmployeeName(employee: Employee) {
  return getFullName(employee.first_name, employee.last_name);
}

export function getEmployeeNamePlusLastInitial(employee: Employee) {
  return `${employee.first_name} ${employee.last_name[0]}.`;
}

export function makePosessive(fullName: string) {
  return `${fullName}'s`;
}

export function getTeamName(team: Team) {
  if (!team) {
    return 'team';
  }
  const ownerFullName = getFullEmployeeName(team.owner);
  return `${makePosessive(ownerFullName)} team`;
}
